import HighlightedPickersList from './HighlightedPickersList.vue'

export default HighlightedPickersList
